<template>
  <ClModal v-model="active" :blur="true" :persistent="true">
    <v-card rounded class="rounded-xl">
      <div class="course-modal">
        <img src="../../../assets/images/courses/DoreJameYazdahom1404-Small.jpg">
        <div class="col-two">
          <div class="course-modal-description p-4">
            <h3>دوره جامع پایه یازدهم سال تحصیلی ۱۴۰۳-۱۴۰۴</h3>

            <p>تدریس کامل تمام مباحث سال یازدهم رشته تجربی, ریاضی و انسانی </p>

            <p>زمان شروع دوره: 20 مرداد </p>

            <p>
              زمان هر جلسه: اختصاصی 3 و عمومی 1:30 الی 2 ساعت
            </p>
          </div>
          <div class="btns-box">
            <a class="btn cl-btn cl-btn-blue "
               @click="gotoFilteredCourses('/courses?courses=385&grades=&lessons=&professors=')">نمایش
              دوره‌ها</a>
          </div>
        </div>
      </div>
    </v-card>
  </ClModal>
</template>

<script>
import ClModal from "@/components/common/ClModal.vue";

export default {
  name: "DoreJameYazdahom1404",
  components: {ClModal},
  props: ['activeCourse'],
  data() {
    return {
      active: false
    }
  },
  mounted() {
    this.active = true
  },
  methods: {
    gotoFilteredCourses(params) {
      this.$router.push(params)
    },
    close() {
      this.active = false;
    }
  },
  watch: {
    activeCourse() {
      this.active = true
    }
  }

}
</script>

<style scoped>
</style>
